import 'ai-app-client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import './styles/index.css';
import { initVisitorTracking } from './utils/visitorTracking';

initVisitorTracking();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
